var map = {
	"./": [
		53774
	],
	"./animation-258fd22b": [
		15688
	],
	"./animation-258fd22b.js": [
		15688
	],
	"./app-globals-70454efb": [
		83881,
		3881
	],
	"./app-globals-70454efb.js": [
		83881,
		3881
	],
	"./button-active-aef107f0": [
		21696,
		1696
	],
	"./button-active-aef107f0.js": [
		21696,
		1696
	],
	"./capacitor-6d1861b7": [
		15080,
		5080
	],
	"./capacitor-6d1861b7.js": [
		15080,
		5080
	],
	"./config-80c044f2": [
		81771
	],
	"./config-80c044f2.js": [
		81771
	],
	"./cubic-bezier-e78d1307": [
		66837
	],
	"./cubic-bezier-e78d1307.js": [
		66837
	],
	"./data-605c040f": [
		57510,
		7510
	],
	"./data-605c040f.js": [
		57510,
		7510
	],
	"./dir-e8b767a8": [
		45213,
		5213
	],
	"./dir-e8b767a8.js": [
		45213,
		5213
	],
	"./focus-visible-10ad4867": [
		22686,
		2686
	],
	"./focus-visible-10ad4867.js": [
		22686,
		2686
	],
	"./form-controller-6cd7ebd1": [
		76646,
		6646
	],
	"./form-controller-6cd7ebd1.js": [
		76646,
		6646
	],
	"./framework-delegate-6a45ed30": [
		50687
	],
	"./framework-delegate-6a45ed30.js": [
		50687
	],
	"./gesture-controller-17060b7c": [
		81033
	],
	"./gesture-controller-17060b7c.js": [
		81033
	],
	"./haptic-d85b8584": [
		69710,
		9710
	],
	"./haptic-d85b8584.js": [
		69710,
		9710
	],
	"./hardware-back-button-490df115": [
		66443
	],
	"./hardware-back-button-490df115.js": [
		66443
	],
	"./helpers-f586db1c": [
		30730
	],
	"./helpers-f586db1c.js": [
		30730
	],
	"./index": [
		53774
	],
	"./index-1204fe95": [
		63498,
		3498
	],
	"./index-1204fe95.js": [
		63498,
		3498
	],
	"./index-36a5fd75": [
		90640
	],
	"./index-36a5fd75.js": [
		90640
	],
	"./index-393bc14a": [
		35214,
		5214
	],
	"./index-393bc14a.js": [
		35214,
		5214
	],
	"./index-422b6e83": [
		31065
	],
	"./index-422b6e83.js": [
		31065
	],
	"./index-6e89f340": [
		26562
	],
	"./index-6e89f340.js": [
		26562
	],
	"./index-7373924f": [
		5528,
		5528
	],
	"./index-7373924f.js": [
		5528,
		5528
	],
	"./index-afea2bcf": [
		58726
	],
	"./index-afea2bcf.js": [
		58726
	],
	"./index-b32cad98": [
		50181
	],
	"./index-b32cad98.js": [
		50181
	],
	"./index-e86f0117": [
		14694
	],
	"./index-e86f0117.js": [
		14694
	],
	"./index.js": [
		53774
	],
	"./input-shims-5b912f6d": [
		55262,
		5262
	],
	"./input-shims-5b912f6d.js": [
		55262,
		5262
	],
	"./input.utils-4c00ca72": [
		95958,
		5958
	],
	"./input.utils-4c00ca72.js": [
		95958,
		5958
	],
	"./ion-accordion_2.entry": [
		5102,
		5102
	],
	"./ion-accordion_2.entry.js": [
		5102,
		5102
	],
	"./ion-action-sheet.entry": [
		48451,
		8451
	],
	"./ion-action-sheet.entry.js": [
		48451,
		8451
	],
	"./ion-alert.entry": [
		18550,
		8550
	],
	"./ion-alert.entry.js": [
		18550,
		8550
	],
	"./ion-app_8.entry": [
		91006,
		1006
	],
	"./ion-app_8.entry.js": [
		91006,
		1006
	],
	"./ion-avatar_3.entry": [
		9169,
		9169
	],
	"./ion-avatar_3.entry.js": [
		9169,
		9169
	],
	"./ion-back-button.entry": [
		9112,
		9112
	],
	"./ion-back-button.entry.js": [
		9112,
		9112
	],
	"./ion-backdrop.entry": [
		59389,
		9389
	],
	"./ion-backdrop.entry.js": [
		59389,
		9389
	],
	"./ion-breadcrumb_2.entry": [
		18249,
		8249
	],
	"./ion-breadcrumb_2.entry.js": [
		18249,
		8249
	],
	"./ion-button_2.entry": [
		17733,
		7733
	],
	"./ion-button_2.entry.js": [
		17733,
		7733
	],
	"./ion-card_5.entry": [
		63298,
		2011
	],
	"./ion-card_5.entry.js": [
		63298,
		2011
	],
	"./ion-checkbox.entry": [
		3562,
		3562
	],
	"./ion-checkbox.entry.js": [
		3562,
		3562
	],
	"./ion-chip.entry": [
		62185,
		2185
	],
	"./ion-chip.entry.js": [
		62185,
		2185
	],
	"./ion-col_3.entry": [
		17478,
		7478
	],
	"./ion-col_3.entry.js": [
		17478,
		7478
	],
	"./ion-datetime-button.entry": [
		80198,
		7510,
		198
	],
	"./ion-datetime-button.entry.js": [
		80198,
		7510,
		198
	],
	"./ion-datetime_3.entry": [
		49440,
		7510,
		9440
	],
	"./ion-datetime_3.entry.js": [
		49440,
		7510,
		9440
	],
	"./ion-fab_3.entry": [
		56608,
		6608
	],
	"./ion-fab_3.entry.js": [
		56608,
		6608
	],
	"./ion-img.entry": [
		88014,
		8014
	],
	"./ion-img.entry.js": [
		88014,
		8014
	],
	"./ion-infinite-scroll_2.entry": [
		16270,
		6270
	],
	"./ion-infinite-scroll_2.entry.js": [
		16270,
		6270
	],
	"./ion-input.entry": [
		42865,
		2865
	],
	"./ion-input.entry.js": [
		42865,
		2865
	],
	"./ion-item-option_3.entry": [
		964,
		964
	],
	"./ion-item-option_3.entry.js": [
		964,
		964
	],
	"./ion-item_8.entry": [
		97419,
		7419
	],
	"./ion-item_8.entry.js": [
		97419,
		7419
	],
	"./ion-loading.entry": [
		966,
		9740
	],
	"./ion-loading.entry.js": [
		966,
		9740
	],
	"./ion-menu_3.entry": [
		19936,
		9936
	],
	"./ion-menu_3.entry.js": [
		19936,
		9936
	],
	"./ion-modal.entry": [
		53731,
		3731
	],
	"./ion-modal.entry.js": [
		53731,
		3731
	],
	"./ion-nav_2.entry": [
		14288,
		4288
	],
	"./ion-nav_2.entry.js": [
		14288,
		4288
	],
	"./ion-picker-column-internal.entry": [
		93064,
		3064
	],
	"./ion-picker-column-internal.entry.js": [
		93064,
		3064
	],
	"./ion-picker-internal.entry": [
		5472,
		5472
	],
	"./ion-picker-internal.entry.js": [
		5472,
		5472
	],
	"./ion-popover.entry": [
		36560,
		6560
	],
	"./ion-popover.entry.js": [
		36560,
		6560
	],
	"./ion-progress-bar.entry": [
		55051,
		5051
	],
	"./ion-progress-bar.entry.js": [
		55051,
		5051
	],
	"./ion-radio_2.entry": [
		62932,
		2932
	],
	"./ion-radio_2.entry.js": [
		62932,
		2932
	],
	"./ion-range.entry": [
		26074,
		6074
	],
	"./ion-range.entry.js": [
		26074,
		6074
	],
	"./ion-refresher_2.entry": [
		28290,
		8290
	],
	"./ion-refresher_2.entry.js": [
		28290,
		8290
	],
	"./ion-reorder_2.entry": [
		53479,
		3479
	],
	"./ion-reorder_2.entry.js": [
		53479,
		3479
	],
	"./ion-ripple-effect.entry": [
		84905,
		4905
	],
	"./ion-ripple-effect.entry.js": [
		84905,
		4905
	],
	"./ion-route_4.entry": [
		85095,
		5095
	],
	"./ion-route_4.entry.js": [
		85095,
		5095
	],
	"./ion-searchbar.entry": [
		57421,
		7421
	],
	"./ion-searchbar.entry.js": [
		57421,
		7421
	],
	"./ion-segment_2.entry": [
		53806,
		3806
	],
	"./ion-segment_2.entry.js": [
		53806,
		3806
	],
	"./ion-select_3.entry": [
		97421,
		6306
	],
	"./ion-select_3.entry.js": [
		97421,
		6306
	],
	"./ion-spinner.entry": [
		63046,
		3046
	],
	"./ion-spinner.entry.js": [
		63046,
		3046
	],
	"./ion-split-pane.entry": [
		34774,
		4774
	],
	"./ion-split-pane.entry.js": [
		34774,
		4774
	],
	"./ion-tab-bar_2.entry": [
		33196,
		3196
	],
	"./ion-tab-bar_2.entry.js": [
		33196,
		3196
	],
	"./ion-tab_2.entry": [
		13965,
		3965
	],
	"./ion-tab_2.entry.js": [
		13965,
		3965
	],
	"./ion-text.entry": [
		42516,
		2516
	],
	"./ion-text.entry.js": [
		42516,
		2516
	],
	"./ion-textarea.entry": [
		12117,
		2117
	],
	"./ion-textarea.entry.js": [
		12117,
		2117
	],
	"./ion-toast.entry": [
		24617,
		4617
	],
	"./ion-toast.entry.js": [
		24617,
		4617
	],
	"./ion-toggle.entry": [
		29125,
		9125
	],
	"./ion-toggle.entry.js": [
		29125,
		9125
	],
	"./ionic": [
		41652,
		1652
	],
	"./ionic-global-a9abd569": [
		36171
	],
	"./ionic-global-a9abd569.js": [
		36171
	],
	"./ionic.js": [
		41652,
		1652
	],
	"./ios.transition-6a838b0c": [
		19147
	],
	"./ios.transition-6a838b0c.js": [
		19147
	],
	"./keyboard-a818f780": [
		2779,
		9852
	],
	"./keyboard-a818f780.js": [
		2779,
		9852
	],
	"./keyboard-cdb83866": [
		67651,
		7651
	],
	"./keyboard-cdb83866.js": [
		67651,
		7651
	],
	"./keyboard-controller-4149afc6": [
		86102,
		6102
	],
	"./keyboard-controller-4149afc6.js": [
		86102,
		6102
	],
	"./loader": [
		40823,
		823
	],
	"./loader.js": [
		40823,
		823
	],
	"./md.transition-b7d7b475": [
		93084
	],
	"./md.transition-b7d7b475.js": [
		93084
	],
	"./notch-controller-cfcb8c01": [
		71107,
		1107
	],
	"./notch-controller-cfcb8c01.js": [
		71107,
		1107
	],
	"./overlays-4801a327": [
		73121
	],
	"./overlays-4801a327.js": [
		73121
	],
	"./spinner-configs-40ada8cd": [
		12517,
		2517
	],
	"./spinner-configs-40ada8cd.js": [
		12517,
		2517
	],
	"./status-tap-211f1ad8": [
		66657,
		6657
	],
	"./status-tap-211f1ad8.js": [
		66657,
		6657
	],
	"./swipe-back-1bb66ed2": [
		51601,
		1601
	],
	"./swipe-back-1bb66ed2.js": [
		51601,
		1601
	],
	"./theme-7670341c": [
		720,
		720
	],
	"./theme-7670341c.js": [
		720,
		720
	],
	"./watch-options-4d421847": [
		66459,
		6459
	],
	"./watch-options-4d421847.js": [
		66459,
		6459
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73076;
module.exports = webpackAsyncContext;